var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(
        [..._vm.editRecords, ...(_vm.disabledRecords ?? [])],
        function (record, index) {
          return _c(
            "div",
            { staticClass: "row border-bottom mb-2" },
            [
              _c("div", { staticClass: "p-0 col-md-2" }, [
                _c(
                  "div",
                  { staticClass: "created_info" },
                  [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$AllDivisions[record.division_id]?.title ??
                            record.division_id
                        ) +
                          "\n          (" +
                          _vm._s(_vm.printDivisionCities(record.division_id)) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    record.status === 1
                      ? [
                          _c("p", { staticClass: "badge badge-primary" }, [
                            _vm._v("не подтверждена"),
                          ]),
                        ]
                      : [
                          _c("p", { staticClass: "text-muted" }, [
                            _vm._v(
                              _vm._s(
                                (record.created_at &&
                                  _vm.printDate(record.created_at)) ||
                                  "новая инкассация"
                              )
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p-0 col-md-3" }, [
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    (_vm.userReceivers ?? []).length
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: record.type_id,
                                expression: "record.type_id",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    record,
                                    "type_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                () => {
                                  record.to_user_id = null
                                  record.to_division_id = null
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "1" } }, [
                              _vm._v("на дивизион"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "5" } }, [
                              _vm._v("пользователю"),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    +record.currency_id !==
                    _vm.$platformConstants.operationCurrency.id
                      ? [
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", disabled: "" },
                            domProps: {
                              value:
                                Math.round(
                                  _vm.getSumByCurrency(
                                    record.sum,
                                    record.currency_id
                                  )
                                ) + " RUB",
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: record.sum,
                          expression: "record.sum",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        disabled:
                          record.readOnly ||
                          record.disabled ||
                          record.to_delete ||
                          record.status === 1,
                        placeholder: "Сумма",
                      },
                      domProps: { value: record.sum },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(record, "sum", $event.target.value)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: record.currency_id,
                            expression: "record.currency_id",
                          },
                        ],
                        staticClass: "form-control currency_select",
                        attrs: {
                          disabled:
                            record.readOnly ||
                            record.disabled ||
                            record.to_delete ||
                            record.status === 1,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              record,
                              "currency_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "0", disabled: "" } }, [
                          _vm._v("Выберите валюту"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.$AllCurrencies, function (curr) {
                          return record.id ||
                            _vm.$currentRole === "admin" ||
                            _vm.allowCurrencies.includes(+curr.id)
                            ? _c("option", { domProps: { value: curr.id } }, [
                                _vm._v(_vm._s(curr.currency) + "\n          "),
                              ])
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "p-0 col-md-4" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: record.comment,
                      expression: "record.comment",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    disabled:
                      record.readOnly || record.disabled || record.to_delete,
                    placeholder: "Комментарий",
                  },
                  domProps: { value: record.comment },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(record, "comment", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-3 flex flex_gap_10 p-0" },
                [
                  (+record.type_id === 1 &&
                    +record.division_id === +_vm.division) ||
                  (+record.type_id === 5 &&
                    record.user_id === _vm.$currentUID) ||
                  record.readOnly
                    ? [
                        _c("div", { staticClass: "p-0 w-100" }, [
                          _c(
                            "div",
                            { staticClass: "flex justify-content-between" },
                            [
                              +record.type_id === 5
                                ? [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: record.to_user_id,
                                            expression: "record.to_user_id",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.$set(
                                              record,
                                              "to_user_id",
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "" },
                                            domProps: { value: null },
                                          },
                                          [_vm._v("Выберите получателя")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.userReceivers ?? [],
                                          function (id) {
                                            return _c(
                                              "option",
                                              { domProps: { value: id } },
                                              [
                                                _c("UserName", {
                                                  attrs: { id: id },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                : [
                                    !(_vm.receivers ?? []).length
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "align-self-center pl-1",
                                            },
                                            [
                                              record.to_user_id
                                                ? _c("UserName", {
                                                    attrs: {
                                                      id: record.to_user_id,
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$AllDivisions[
                                                      record.to_division_id
                                                    ]?.title
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      : [
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: record.to_division_id,
                                                  expression:
                                                    "record.to_division_id",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                disabled:
                                                  record.to_delete ||
                                                  record.status === 1 ||
                                                  record.disabled,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    record,
                                                    "to_division_id",
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._l(
                                                _vm.receivers,
                                                function (receiver) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: receiver.id,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            receiver.id === 0
                                                              ? "Администрация"
                                                              : receiver.title +
                                                                  " (" +
                                                                  receiver?.user
                                                                    ?.short_name +
                                                                  ")"
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              _vm._v(" "),
                                              record?.id
                                                ? _vm._l(
                                                    _vm.getSavedReceivers(),
                                                    function (r) {
                                                      return r
                                                        ? _c(
                                                            "option",
                                                            {
                                                              domProps: {
                                                                value: r.id,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      " +
                                                                  _vm._s(
                                                                    r.title +
                                                                      " (" +
                                                                      r?.user
                                                                        ?.short_name +
                                                                      ")"
                                                                  ) +
                                                                  "\n                    "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                  ],
                              _vm._v(" "),
                              _vm.$currentRole === "admin" ||
                              (record.user_id === _vm.$currentUID &&
                                !record.is_confirmed)
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger",
                                      on: {
                                        click: function ($event) {
                                          record.to_delete = !record.to_delete
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icon-fa icon-fa-remove",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "p-l-5 align-self-center" }, [
                          _vm._v("\n          Входящая инкассация\n          "),
                          record.type_id === 5
                            ? _c(
                                "div",
                                [
                                  _c("UserName", {
                                    attrs: { id: record.user_id },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _vm.$currentRole === "admin"
                ? _c("div", { staticClass: "col-md-2 p-0" }, [
                    _c("p", [
                      _c("label", { staticClass: "mb-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: record.data.by_trader,
                              expression: "record.data.by_trader",
                            },
                          ],
                          attrs: {
                            disabled:
                              record.readOnly ??
                              (record.created_by &&
                                record.created_by !== _vm.$currentUID),
                            type: "checkbox",
                          },
                          domProps: {
                            checked: Array.isArray(record.data.by_trader)
                              ? _vm._i(record.data.by_trader, null) > -1
                              : record.data.by_trader,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = record.data.by_trader,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        record.data,
                                        "by_trader",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        record.data,
                                        "by_trader",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(record.data, "by_trader", $$c)
                                }
                              },
                              function ($event) {
                                return _vm.useTrader(index)
                              },
                            ],
                          },
                        }),
                        _vm._v(" Через обменник"),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              record.data.by_trader
                ? [
                    _c("div", { staticClass: "col-md-3 p-0" }, [
                      _c("div", { staticClass: "flex" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: record.data.converted_sum,
                              expression: "record.data.converted_sum",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "number",
                            disabled: record.readOnly,
                            placeholder: "Сумма в USDT",
                          },
                          domProps: { value: record.data.converted_sum },
                          on: {
                            change: function ($event) {
                              return _vm.updateRecordRate(index)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                record.data,
                                "converted_sum",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: record.data.rate,
                              expression: "record.data.rate",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            disabled: record.readOnly,
                            placeholder: "Курс",
                            disabled: "",
                          },
                          domProps: { value: record.data.rate },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(record.data, "rate", $event.target.value)
                            },
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.$currentRole === "admin"
                      ? [
                          _c("div", { staticClass: "col-md-4 p-0 flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: record.data.receive_address,
                                  expression: "record.data.receive_address",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Куда",
                                disabled: record.readOnly,
                              },
                              domProps: { value: record.data.receive_address },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    record.data,
                                    "receive_address",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: record.data.send_address,
                                  expression: "record.data.send_address",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "Откуда",
                                disabled: record.readOnly,
                              },
                              domProps: { value: record.data.send_address },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    record.data,
                                    "send_address",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-3 p-0" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: record.data.aml_risk,
                                  expression: "record.data.aml_risk",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                placeholder: "AML Risk",
                                disabled: record.readOnly,
                              },
                              domProps: { value: record.data.aml_risk },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    record.data,
                                    "aml_risk",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          )
        }
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-content-between p-t-10" },
        [
          (_vm.receivers ?? []).length || (_vm.userReceivers ?? []).length
            ? _c(
                "button",
                {
                  staticClass: "btn btn-info",
                  on: {
                    click: function ($event) {
                      return _vm.addNew()
                    },
                  },
                },
                [_vm._v("\n      Добавить инкассацию\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-success",
                "data-style": "zoom-in",
                loading: _vm.loading,
              },
              on: { click: _vm.save },
            },
            [_vm._v("Сохранить инкассации\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }